'use client';

import classnames from 'classnames';

import { assetUrl } from '../../../utils/asset';
import type { PlayerCardProps } from './PlayerCard.types';
import { ReactComponent as AwardImg } from './icons/award';
import DefaultThumbnailAsset from './images/default-thumbnail.png';

import styles from './PlayerCard.module.scss';

const DefaultThumbnail = assetUrl(DefaultThumbnailAsset);

function PlayerCard({
  style,
  className,
  username,
  points,
  type = 'gold',
  image,
  active = false,
  testId = 'ui-player-card',
}: PlayerCardProps) {
  return (
    <div
      style={style}
      className={classnames(styles['player-card'], className)}
      data-testid={testId}
    >
      <div
        className={classnames(
          styles['card'],
          active && styles['card--active'],
          type && styles[`card--${type}`],
        )}
      >
        <svg
          height="0"
          width="0"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 267.3 427.3"
        >
          <clipPath id="svgPath">
            <path
              fill="#000"
              d="M265.3 53.9a33.3 33.3 0 0 1-17.8-5.5 32 32 0 0 1-13.7-22.9c-.2-1.1-.4-2.3-.4-3.4 0-1.3-1-1.5-1.8-1.9a163 163 0 0 0-31-11.6A257.3 257.3 0 0 0 133.7 0a254.9 254.9 0 0 0-67.1 8.7 170 170 0 0 0-31 11.6c-.8.4-1.8.6-1.8 1.9 0 1.1-.2 2.3-.4 3.4a32.4 32.4 0 0 1-13.7 22.9A33.8 33.8 0 0 1 2 53.9c-1.5.1-2.1.4-2 2v293.9c0 3.3 0 6.6.4 9.9a22 22 0 0 0 7.9 14.4c3.8 3.2 8.3 5.3 13 6.8 12.4 3.9 24.8 7.5 37.2 11.5a388.7 388.7 0 0 1 50 19.4 88.7 88.7 0 0 1 25 15.5v.1-.1c7.2-7 16.1-11.3 25-15.5a427 427 0 0 1 50-19.4l37.2-11.5c4.7-1.5 9.1-3.5 13-6.8 4.5-3.8 7.2-8.5 7.9-14.4.4-3.3.4-6.6.4-9.9V231.6 60.5v-4.6c.4-1.6-.3-1.9-1.7-2z"
            />
          </clipPath>
        </svg>
        <div className={styles['card-inner']}>
          <div
            className={classnames(
              styles['card-top'],
              type && styles[`card-top--${type}`],
            )}
          >
            <img
              className={styles['thumbnail']}
              alt=""
              src={image === undefined ? DefaultThumbnail : image}
            />
            <div
              className={classnames(
                styles['backfont'],
                active && styles['backfont--active'],
              )}
            >
              OPN
            </div>
          </div>
          <div
            className={classnames(
              styles['card-bottom'],
              type && styles[`card-bottom--${type}`],
            )}
          >
            <div
              className={classnames(
                styles['name'],
                active && styles['name--active'],
              )}
            >
              {username}
            </div>
            <div
              className={classnames(
                styles['stats'],
                active && styles['stats--active'],
              )}
            >
              <div className={styles['award']}>
                <div className={styles['award__image']}>
                  <AwardImg height="100%" width="100%" />
                </div>
                <span className={styles['award__points']}>{points ?? 0}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { PlayerCard };
